import MuiDivider, { DividerProps } from "@mui/material/Divider";
const Divider: React.FC<DividerProps> = (props) => {
  return <MuiDivider {...props} />;
};

export default Divider;
